module.exports = __webpack_public_path__ + "static/media/background-triangle.b55292c6.svg";